export default __webpack_public_path__ + "static/media/trainings.3d757c12.png";